import React from "react";
// import { Col } from "reactstrap";

const DonationSlabs = ({
    amountList,
    activeSelection,
    setActiveSelection,
    isCustomAmount,
    setIsCustomAmount,
}) => {
    return (
        <>
            <div className="d-flex flex-wrap">
                {amountList.map((item, i) => (
                    <div
                        className={`amount-btn amount border rounded px-3 py-2 mb-2 mr-4 ${
                            activeSelection.amount === item.amount
                                ? "amount-btn-active"
                                : ""
                        }`}
                        onClick={() => {
                            setIsCustomAmount(false);
                            setActiveSelection({
                                amount: item.amount,
                                cause: item.cause,
                            });
                        }}
                        key={i}
                    >
                        <span className="mr-2">&#8377;</span>
                        <span>{item.label}</span>
                    </div>
                ))}
                <div
                    className={`border p-2 rounded mb-2 custom-amount amount-btn ${
                        isCustomAmount ? "amount-btn-active" : ""
                    }`}
                    onClick={() => {
                        if (isCustomAmount) {
                            return;
                        }
                        setIsCustomAmount(true);
                        setActiveSelection((activeSelection) => ({
                            ...activeSelection,
                            amount: 1000,
                            cause: "I would like to contribute (Amount of your Choice)",
                        }));
                    }}
                >
                    <span className="mr-2">&#8377;</span>
                    <input
                        type="text"
                        value={isCustomAmount ? activeSelection.amount : ""}
                        className={`border-0  custom-amount-text ${
                            isCustomAmount ? "custom-amount-text-active" : ""
                        }`}
                        onChange={(e) =>
                            setActiveSelection((activeSelection) => ({
                                ...activeSelection,
                                amount: e.target.value,
                            }))
                        }
                        placeholder="____"
                    />
                </div>
            </div>
        </>
    );
};

export default DonationSlabs;
